import React, { useEffect, useState } from 'react'
import axios from 'axios'
import Home from './components/Home'
import { BrowserRouter, Routes,Route } from 'react-router-dom'
import SingleVideo from './components/SingleVideo'
import Login from './components/Login'
import OtpValidationPage from './Pages/OtpValidationPage'
import SubscriptionPage from './Pages/SubscriptionPage'
import CheckCookieRedirect from './components/CheckCookieRedirect'
import Subscription from './Pages/Subscription'
import Promo from './Pages/Promo'
const App = () => {

  return (
    <div>
     <BrowserRouter>
       <Routes>
       <Route path='/subscribe' element={<Subscription />} />

        <Route path='/login' element={<Login/>}/>
          <Route path='/' element={<Home/>}/>
           <Route path='/videos/:id' element={<SingleVideo/>}/>
           <Route path="/otp" element={<SubscriptionPage/>}/>
          
          <Route path="/otp-validation" element={<OtpValidationPage/>}/>
          <Route path="/promo" element={<Promo/>}/>
       </Routes>
      
     </BrowserRouter>
    
    </div>
  )
}

export default App
